document.querySelectorAll('section:not(.top) .ag_mediatextlist.fl-slider .splide').forEach(function (slider) {

    import(modules.splide).then(module => {
        let Splide = module.default;
        let imageMediaSlider = new Splide(slider, {
            type: 'loop',
            speed: 300,
            /*type: 'fade',
            speed: 1000,*/
            autoplay: false,
            pauseOnHover: false,
            interval: 2800,
            perPage: 2,
            perMove: 1,
            pagination: true,
            arrows: true,
            rewind: true,
            mediaQuery: 'min',
            breakpoints: {
                640: {
                    perPage: 2,
                },
                1000: {
                    perPage: 2,
                },
            }
        }).mount();

        imageMediaSlider.on('move', function () {
            slider.querySelectorAll('video').forEach(function (video) {
                video.currentTime = 0;
            });
        });

    });


});

document.querySelectorAll('section.top .ag_mediatextlist.fl-slider .splide').forEach(function (slider) {

    import(modules.splide).then(module => {
        let Splide = module.default;
        let imageMediaSlider = new Splide('.ag_mediatextlist .splide', {
            /*type: 'loop',
            speed: 300,*/
            type: 'fade',
            speed: 1000,
            autoplay: false,
            pauseOnHover: false,
            interval: 2800,
            perPage: 1,
            perMove: 1,
            pagination: false,
            arrows: false,
            rewind: true,
            mediaQuery: 'min',
            breakpoints: {
                640: {
                    perPage: 1,
                },
                1000: {
                    perPage: 1,
                },
            }
        }).mount();

        imageMediaSlider.on('move', function () {
            slider.querySelectorAll('video').forEach(function (video) {
                video.currentTime = 0;
            });
        });

    });

});





